import { BaseApiRepository } from "@/core/infrastructure/BaseApiRepository";
import { ClientOrdersRepository } from "../domain/repositories/ClientOrdersRepository";
import { ClientOrderCreateRequest, ClientOrderUpdateRequest, ResponseClientInstruments, ResponseClientOrder, ResponseClientOrderKV, ResponseClientRates } from "../domain/entities/ClientOrdersEntity";

export class ClientOrdersApiRepository extends BaseApiRepository implements ClientOrdersRepository {
  async getAllClientOrders(): Promise<ResponseClientOrderKV> {
    const result = await this.request<ResponseClientOrderKV>("/api/client_orders");
    return result;
  }

  async getClientOrderById(id: string): Promise<ResponseClientOrderKV> {
    const result = await this.request<ResponseClientOrderKV>(`/api/client_orders/${id}`);
    return result;
  }

  async createClientOrder(order: ClientOrderCreateRequest): Promise<ResponseClientOrder> {
    const result = await this.request<ResponseClientOrder>("/api/client_orders", {
      method: "POST",
      body: JSON.stringify(order),
    });
    return result;
  }

  async updateClientOrder(order: ClientOrderUpdateRequest): Promise<ResponseClientOrder> {
    const result = await this.request<ResponseClientOrder>(`/api/client_orders/${order.id}`, {
      method: "PUT",
      body: JSON.stringify(order),
    });
    return result;
  }

  async deleteClientOrder(id: string): Promise<ResponseClientOrder> {
    const result = await this.request<ResponseClientOrder>(`/api/client_orders/${id}`, {
      method: "DELETE",
    });
    return result;
  }

  async getAllClientInstruments(): Promise<ResponseClientInstruments> {
    return await this.request<ResponseClientInstruments>("/api/instruments");
  }

  async getAllClientRates(): Promise<ResponseClientRates> {
    return await this.request<ResponseClientRates>("/api/rates");
  }
}
